import * as React from 'react';
import { SVGProps } from 'react';

const IconBookmarkStrokedSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m14 22 9 4V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v22l9-4Zm-6-.616 6-2.667 6 2.667V5H8v16.384Z"
    />
  </svg>
);
export default IconBookmarkStrokedSizeL;
